import { render, staticRenderFns } from "./teacherClasses.vue?vue&type=template&id=62a11907&"
import script from "./teacherClasses.vue?vue&type=script&lang=js&"
export * from "./teacherClasses.vue?vue&type=script&lang=js&"
import style1 from "./teacherClasses.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports